import {IFeatureCardProps} from "./FeatureCard";
import {IFeature} from "./Feature";

interface IMobileFeatureCardProps {
    feature: IFeature
    fullScreen: boolean
}

export default function MobileFeatureCard(props: IMobileFeatureCardProps) {
    let imageStyle = props.feature.image_style
    return <div className="Feature_card_container_mobile">
        <div className="Feature_card_mobile">
            {(imageStyle === "top") && <img className="Feature_card_mobile__image_top" src={props.feature.image}/>}
            {imageStyle === "rounded" && <img className="Feature_card_mobile__image_rounded" src={props.feature.image}/>}
            <div className="Feature_card_mobile__header">
                <div className="Feature_card_mobile__title">
                    {props.feature.title}
                </div>
                <div className="Feature_card_mobile__subtitle">
                    {props.feature.subtitle}
                </div>
            </div>
            {(imageStyle === "bottom" || imageStyle === "center") && <div className="Feature_card_mobile__image_bottom_container" style={{top: `${props.fullScreen ? "33%" : "44%"}`}}>
                <img className="Feature_card_mobile__image_bottom" src={props.feature.image}/>
            </div>
            }
        </div>
        <div className="Car_card_shadow"/>
    </div>
}